// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3TEgx","name":"styles_name__3f1R9","phone":"styles_phone__1WWbN"};